import { useMsal } from '@azure/msal-react';
import { requestScopes } from 'src/authConfig';
import { Button } from 'src/components/ui/button'
import { useMS } from './context/MSContext';
import microsoftLogo from 'src/assets/logo/microsoft.svg'
import { MoveRight } from 'lucide-react';
import { cleanupTrash } from 'src/graph';
const Login = () => {
    const { instance } = useMsal();
    const { setaccessToken } = useMS()

    const handleLogin = (loginType:string) => {
        if (loginType === "popup") {
            instance.loginPopup(requestScopes).catch(e => {
                console.log(e);
            }).then((response) => { if(response){ setaccessToken(response.accessToken); cleanupTrash(response.accessToken) } })
        } else if (loginType === "redirect") {
            instance.loginRedirect(requestScopes).catch(e => {
                console.log(e);
            })
        }
    }

  return (
    <div className='flex justify-center items-center h-full w-full bg-gradient-to-br from-indigo-100 via-fuchsia-100 to-orange-100'>
        <div className='p-10 shadow-md bg-white flex flex-col gap-4'>
            <div><img className='h-6 w-auto' src={microsoftLogo} alt="Microsoft Logo"/></div>
            <p className='text-xl font-semibold'>Inloggen</p>
            <p>Gelieve in te loggen in uw Microsoft account.</p>
            <Button onClick={() => handleLogin("popup")} className='gap-2'>Inloggen in Microsoft <MoveRight className='w-4 h-4'/></Button>
        </div>
    </div>
  )
}

export default Login